import { kebabCase } from "lodash";

export const stripRelationshipData = (body) => {
  let relationships: Record<string, any> = body.data.relationships;
  if (!relationships) return body;

  relationships = Object.entries(relationships)
    .filter(([_, value]) => Array.isArray(value.data))
    .map(([key, value]): [string, { data: any }] => [
      key,
      { data: value.data.map(({ id, type }) => ({ id, type })) },
    ])
    .reduce((acc, [key, value]) => {
      acc[key] = value;
      return acc;
    }, {});

  return {
    data: {
      ...body.data,
      relationships,
    },
  };
};

function queryFormat(value, key) {
  if (value !== null && Array.isArray(value))
    return value.map((v) => queryFormat(v, key + "[]")).join("&");
  else if (value !== null && typeof value === "object")
    return query(value, key);
  else return encodeURIComponent(key) + "=" + encodeURIComponent(value);
}

/**
 * Constructs a URL query string for JSON:API parameters
 *
 * @param {Object} [params] Parameters to parse
 * @param {string} [prefix] Prefix for nested parameters - used internally
 * @returns {string} URL query string
 *
 * @example
 * query({
 *   filter: {
 *     slug: 'cowboy-bebop',
 *     title: {
 *       value: 'foo'
 *     }
 *   }
 *  sort: '-id'
 * })
 * // filter%5Bslug%5D=cowboy-bebop&filter%5Btitle%5D%5Bvalue%5D=foo&sort=-id
 */
export function query(params, prefix = null) {
  const str: string[] = [];

  for (const param in params) {
    if (params[param] !== null && params[param] !== undefined) {
      str.push(
        queryFormat(
          params[param],
          prefix ? `${prefix}[${kebabCase(param)}]` : kebabCase(param)
        )
      );
    }
  }
  return str.filter(Boolean).join("&");
}
